var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.componentPath)?_c('AsyncComponent',_vm._g(_vm._b({attrs:{"component-path":_vm.componentPath,"show-load":false}},'AsyncComponent',_vm.$attrs,false),_vm.$listeners)):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }